import { InjectionToken } from '@angular/core';
import { EntitiesModel, Permission } from '../../../model';
import { Converter } from '../../../util';

export const PERMISSION_NORMALIZER = new InjectionToken<Converter<any, Permission>>('PermissionNormalizer');

export const PERMISSIONS_NORMALIZER = new InjectionToken<Converter<any, EntitiesModel<Permission>>>('PermissionsListNormalizer');

export const PERMISSION_SERIALIZER = new InjectionToken<Converter<Permission, any>>('PermissionSerializer');
